import * as React from 'react';
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from '@mui/icons-material/Edit';
import PlaylistRemoveIcon from '@mui/icons-material/PlaylistRemove';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
import VisibilityIcon from '@mui/icons-material/Visibility';

import AppContext from "app/AppContext";

export default function AccountMenu(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    event.stopPropagation();
    
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <React.Fragment>
      <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}
        className="questions-menu-button">
        <Tooltip title={AppContext.r["question-options"]}>
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2 }}
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}>
            <MoreVertIcon />
          </IconButton>
        </Tooltip>
      </Box>

      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>

        <MenuItem onClick={() => {
            if(props.onEdit) {
                props.onEdit();
            } else if(props.onView) {
                props.onView();
            }}}>

            {props.onEdit && <>
                <ListItemIcon>
                    <EditIcon fontSize="small" />
                </ListItemIcon>

                {AppContext.r["edit"]}
            </>}

            {!props.onEdit && <>
                <ListItemIcon>
                    <VisibilityIcon fontSize="small" />
                </ListItemIcon>

                {AppContext.r["view"]}
            </>}
        </MenuItem>

        <Divider />
        
        {props.onDelete && 
            <MenuItem onClick={() => props.onDelete() }>
                <ListItemIcon>
                    <PlaylistRemoveIcon fontSize="small" />
                </ListItemIcon>
                    {AppContext.r["delete"]}
            </MenuItem> }
        
        {props.onRemoveFromPlaylist && 
            <MenuItem onClick={() => props.onRemoveFromPlaylist() }>
                <ListItemIcon>
                    <PlaylistRemoveIcon fontSize="small" />
                </ListItemIcon>
                    {AppContext.r["remove-from-playlist"]}
            </MenuItem> }

        {props.onMoveToPlaylist && 
            <MenuItem onClick={() => props.onMoveToPlaylist() }>
                <ListItemIcon>
                    <DriveFileMoveIcon fontSize="small" />
                </ListItemIcon>
                    {AppContext.r["move-to-playlist"]}
            </MenuItem> }

        {props.onCopyToPlaylist && 
            <MenuItem onClick={() => props.onCopyToPlaylist() }>
                <ListItemIcon>
                    <PlaylistAddIcon fontSize="small" />
                </ListItemIcon>
                    {AppContext.r["copy-to-playlist"]}
            </MenuItem> }
        
      </Menu>
    </React.Fragment>
  );
}
